import React from 'react';
import { withPostHog } from '@/lib/withPostHog'; 

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error.name === 'UploadValidationError') {
      console.warn('Handled validation error:', error);
      return;
    }

    // Safely check for posthog
    if (this.props.posthog) {
      this.props.posthog.capture('react_error', {
        error: error.toString(),
        componentStack: errorInfo.componentStack,
        path: window.location.pathname
      });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-fallback min-h-screen bg-gray-900 flex items-center justify-center">
          <div className="text-center p-8 bg-gray-800 rounded-lg max-w-2xl">
            <h2 className="text-2xl font-bold text-red-500 mb-4">
              Oops! Something went wrong.
            </h2>
            <p className="text-gray-300 mb-6">
              Our team has been notified. Please try refreshing the page or
              contact support if the problem persists.
            </p>
            <button
              onClick={this.handleRetry}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wrap in `withPostHog` so `this.props.posthog` is provided
export default withPostHog(ErrorBoundary);